import { Navigate, useLocation } from "react-router-dom";

// `/dashboard/director` abre a Visão do dono, preservando `?company_id=`.
const OwnerRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`/dashboard/director/owner${search || ""}`} replace />;
};

export default OwnerRedirect;
